/** Shopify CDN: Minification failed

Line 16:1 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 17:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 22:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 27:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 29:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 38:9 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
	class BackToTop extends HTMLElement {
	  constructor() {
			super();
			this.pageHeight = window.innerHeight;
	  }

		connectedCallback() {
			this.addEventListener('click', this.onClick);
			window.addEventListener('scroll', this.checkVisible.bind(this));
		}

		checkVisible(event) {
			window.requestAnimationFrame(() => {
				let y = window.scrollY;
		    if (y > this.pageHeight) {
		      this.classList.add('back-to-top--active');
		    } else {
					this.classList.remove('back-to-top--active');
				}
			});
	  }

		onClick() {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth"
			});
	  }
	}
	customElements.define('back-to-top', BackToTop);
}
